import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

    transform(array: Array<{}>, key: string, direction: string): Array<string> | Array<{}> {

        array = array || [];

        if (!key || !direction) {
            return array;
        }

        if (direction == "ASC" || direction == "DESC") {
            return _.orderBy(array, (item:any) => item[key], direction.toLowerCase());
        }

        return array;
    }
}